<template>
  <Background :theme="background">
    <div :class="sectionClasses">
      <div
        :class="{
          'container mx-auto px-0': true,
        }"
      >
        <PortableText
          v-if="Content?.footerPortableText"
          :portable-data="Content.footerPortableText"
          :class="{ 'hero-content-text': true }"
        />
      </div>
    </div>
  </Background>
</template>

<script lang="ts" setup>
import type { HeroContent } from '~/sanity/types';

const props = defineProps<HeroContent>();
const { paddingBottom, paddingTop } = toRefs(props);

const sectionClasses = computed(() => ({
  'padding-wrapper hero-content': true,
  [paddingTop?.value ? paddingTopClasses[paddingTop.value] : 'pt-5']: true,
  [paddingBottom?.value ? paddingBottomClasses[paddingBottom.value] : 'pb-5']: true,
}));
const paddingTopClasses: Record<string, string> = {
  default: 'pt-5',
  '20px': 'pt-5',
  '40px': 'pt-10',
  '80px': 'pt-20',
  '100px': 'pt-100px',
  '120px': 'pt-120px',
  '200px': 'pt-200px',
  '0px': 'pt-0',
};
const paddingBottomClasses: Record<string, string> = {
  default: 'pb-5',
  '20px': 'pb-5',
  '40px': 'pb-10',
  '80px': 'pb-20',
  '100px': 'pb-100px',
  '120px': 'pb-120px',
  '200px': 'pb-200px',
  '0px': 'pb-0',
};
</script>

<style lang="scss">
.hero-content-text {
  h1 {
    font-size: 3.5rem !important;
    font-weight: 800 !important;
    line-height: 60px !important;
    margin-bottom: 16px;
  }
  & > p {
    font-size: 1.5rem !important;
    line-height: 2.6875rem !important;
  }
  h4 {
    font-size: 25px !important;
    font-weight: 500 !important;
  }
  .signup-headline-list {
    align-items: center;
    flex-direction: column;
    gap: 10px;
    @media (min-width: 768px) {
      flex-direction: row;
      gap: 45px;
    }
    .dot {
      background: #dedede;
      border-radius: 50%;
      height: 10px;
      width: 10px;
      display: none;
      @media (min-width: 768px) {
        display: block;
      }
    }
    li.item {
      color: #00890b;
      font-family: Rajdhani;
      font-size: 20px;
      font-weight: 700;
      line-height: normal;
      text-align: center;
    }
  }
}
</style>
